module["exports"] = [
  "Italia"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/it/address/default_country.js
// module id = 1236
// module chunks = 1